<template>
  <BreadCrumb PageTitle="Account Settings" />
  <AccountSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AccountSettings from "../../components/Settings/AccountSettings.vue";

export default defineComponent({
  name: "AccountSettingsPage",
  components: {
    BreadCrumb,
    AccountSettings,
  },
});
</script>